<template>
  <header>
    <div class="header row">
      <div class="headerBrand col-6 col-xl-5 col-lg-6 col-md-6">
        <div class="headerLogo">
          <a href="#" class="brandIcon">
            <img src="../../assets/img/endesa.png" alt="consent" class="imgLogo">
          </a>
        </div>
      </div>
      <div v-if="userName" class="headerLink col-md-6 text-right col-5">
        <div v-if="!movilSize" class="lineMenuHeader">
          <span class="lineMenuRight">
          <a  class="nav-link button linksTopMenu" @click="viewAlt">Alta</a>
          <a  class="nav-link button linksTopMenu" @click="viewContracts">Necesidades</a>
          <a  class="nav-link button linksTopMenu" @click="logout">Salir</a>
          <div class="headerUser">{{userName}}</div>
          </span>
        </div>
        <div v-else class="movilMenuHeader">
          <b-navbar-nav>
            <b-nav-item-dropdown  :text="userName" right>
            <a class="dropdown-item" @click="viewAlt">Alta</a>
              <a class="dropdown-item" @click="viewContracts">Necesidades</a>
              <div v-if="rol" class="dropdown-divider"></div>
              <a class="dropdown-item"  @click="logout">Salir</a>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name:'common-header',
  data(){
    return{
        rol: null,
        userName: null,
        innerWidth: window.innerWidth,
        showLinkMenu : false
    }
  },
  created(){
    window.addEventListener('resize', this.handleHeader)
    this.$bus.$on(this.$constants.busEventOnLogin, payload => { this.updateHeader() })
  },
  mounted(){
    this.updateHeader()
  },
  beforeDestroy () {
    this.$bus.$off(this.$constants.busEventOnLogin)
  },
  computed: {
    movilSize(){
        return this.innerWidth < this.$constants.minSizeHeader
    }
  },
  methods:{
    handleHeader() {
        this.innerWidth = window.innerWidth
    },
    updateHeader(){
        this.rol = this.$session.get('rol')
        this.userName = this.$session.get('user')
    },
    viewBO(){
        this.$router.push({
            name: this.$constants.routerAgencies
        }).catch(err => {})
    },
    viewAlt(){
        this.$router.push({
            name: this.$constants.routerAlt
        }).catch(err => {})
    },
    viewContracts(){
        this.$router.push({
            name: this.$constants.routerContracts
        }).catch(err => {})
    },
    logout(){
        this.$session.destroy()
        this.updateHeader()
        this.$router.push({
            name: this.$constants.routerLogin
        }).catch(err => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/header.vue